import styled from 'styled-components';

export const SupportPgContainer = styled.div`
  width: 1200px;
  margin: 0 auto;
  margin-top: -100px;
  background: #ffffff;
  box-shadow: 0px 3px 30px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 24px 47px 40px 47px;
  margin-bottom: 20px;
`;
